<template>
<!-- 4张图样式 -->
  <div
    id="fourPic"
    class="fourPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
  >
  <div class="pic-group">
    <div  class="left child-pic" >
          <img @click="goLink(tbInfo.link1)" :src="tbInfo.image1"  class="pic" :class="tbInfo.link1?'link':''"/>
    </div>
    <div  class="right child-pic">
      <img @click="goLink(tbInfo.link2)" :src="tbInfo.image2"  class="pic" :class="tbInfo.link2?'link':''"/>
    </div>
  </div>
   <div class="pic-group">
    <div  class="left child-pic" 
    >
      <img @click="goLink(tbInfo.link3)" :src="tbInfo.image3"  class="pic" :class="tbInfo.link3?'link':''"/>
    </div>
    <div  class="right child-pic" 
    >
      <img @click="goLink(tbInfo.link4)" :src="tbInfo.image4"  class="pic" :class="tbInfo.link4?'link':''"/>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fourPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["tbInfo","backgroundPic"],
  methods: {
    // 跳转链接
    goLink(link){
      if(link){
         window.open(link)
      }
    }
  },
  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.fourPic {
  width: auto;
  height: 100%;
  background-position: center;
  background-size: cover;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 80px;
}
.pic-group {
  width: 100%;
  height: 242px;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  margin-top: 10px;
  box-sizing: border-box;
}
.fourPic .child-pic{
  flex:1;
  height: 100%;
  display: flex;
}
.fourPic .left{
  justify-content: right;
  padding-right: 7px;
}
.fourPic .right{
  padding-left: 7px;
  justify-content: left;
}
.fourPic .child-pic img{
  width: 320px;
  height: 240px;
  -o-object-fit: cover;
  object-fit: cover;
}

.fourPic .child-pic .link{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/fourPic.vue